import toast from '@liquidweb-dev/undercurrent/toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicAccountUserStateDataRemoveParamsRawI,
	LWApiPublicAccountUserStateDataRemoveResultRawI,
} from '@liquidweb-dev/club-sauce/public/account/user/stateData/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import { ACCOUNT_USER_STATEDATA_LISTFORKEY_QUERY_KEY } from './useListForKey';

const useStateDataRemove = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation<
		LWApiPublicAccountUserStateDataRemoveResultRawI,
		ApiErrorI,
		LWApiPublicAccountUserStateDataRemoveParamsRawI
	>({
		mutationFn: (params) => api.account.user.stateData.apiRaw.remove(params),

		onSuccess: (_data, vars) => {
			queryClient.invalidateQueries({
				queryKey: [
					ACCOUNT_USER_STATEDATA_LISTFORKEY_QUERY_KEY,
					{ key: vars.key },
				],
			});
		},

		onError: snackbarError,
	});
};

export const useRemoveFavorite = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation<
		LWApiPublicAccountUserStateDataRemoveResultRawI,
		ApiErrorI,
		{ uuid: string }
	>({
		mutationFn: ({ uuid }) =>
			api.account.user.stateData.apiRaw.remove({
				key: 'favorites',
				uuid,
			}),

		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [
					ACCOUNT_USER_STATEDATA_LISTFORKEY_QUERY_KEY,
					{ key: 'favorites' },
				],
			});

			toast.success('Removed from favorites');
		},

		onError: snackbarError,
	});
};

export default useStateDataRemove;
